import NotesList from './components/NotesList';

export default function App() {
  return (
    <div className='App'>
      <NotesList />
    </div>
  );
}
